import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: '[acSelectOption]' })
/**
 * This directive is for forcing option in ac-dropdown to have limited length and assigning the title on hover when the text got truncate
 */
export class AcSelectOptionDirective implements OnInit {
	@Input() public acSelectOption: string;
	constructor(private elementRef: ElementRef, private renderer: Renderer2) { }
	private hardLimitOfChars: number = 56;
	public ngOnInit(): void {
		this.initEmbeddedView();
	}
	private initEmbeddedView(): void {
		const child: HTMLSpanElement = document.createElement('span');
		let resultString = this.acSelectOption;
		if (this.acSelectOption && this.acSelectOption.length > this.hardLimitOfChars) {
			resultString = this.acSelectOption.substr(0, this.hardLimitOfChars - 3) + '...';
			this.renderer.setAttribute(this.elementRef.nativeElement, 'title', this.acSelectOption);
		}
		child.textContent = resultString;
		this.renderer.appendChild(this.elementRef.nativeElement, child);
	}
}
